<template>

	<div>

		<div class="col-md-7">

			<label class="control-label" v-translate>Filtrar pelo aluno:</label>

			<div class="form-group">

				<div class="input-group">

					<span class="input-group-btn">

						<button class="btn default" type="button">
							<i class="fa fa-user" aria-hidden="true"></i>
						</button>

					</span>

					<input class="form-control" placeholder="Nome do aluno" type="text" v-model="student">

				</div>

			</div>

		</div>

		<div class="col-md-3">

			<label class="control-label" v-translate>Filtrar por data:</label>

			<div class="form-group">

				<div class="input-group">

					<span class="input-group-btn">

						<button class="btn default" type="button">
							<i class="fa fa-calendar"></i>
						</button>

					</span>

					<date-picker type="date" v-model="datepicker.selected" :editable="false" format="dd/MM/yyyy" :clearable="false" />

				</div>

			</div>

		</div>

		<div class="col-md-2">

			<button type="button" class="btn yellow-gold btn-block m-t-24" @click="filter">
				<i class="fa fa-search" aria-hidden="true"></i>
				<span v-translate>Filtrar</span>
			</button>

		</div>

	</div>

</template>

<script>

	import MedicineFilters from './';
	export default MedicineFilters;

</script>



// WEBPACK FOOTER //
// medicine-filters.vue?a56f1ef2